import React from 'react';
import { StarIcon } from 'lucide-react';
import { Section } from './Shared';
export type TestimonialProps = {
  initials: string;
  name: string;
  location: string;
  product: string;
  text: string;
};
export function TestimonialCard({
  initials,
  name,
  location,
  product,
  text
}: TestimonialProps) {
  return <article className="glass-panel flex h-full flex-col rounded-2xl p-6 md:p-7" data-id="element-290" data-mp="3azjetzqo6od9">
      <div className="mb-4 flex items-center gap-3" data-id="element-291" data-mp="36z97ojr55rwt">
        <div className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full border border-brand-gold/55 bg-brand-surfaceLight font-serif font-bold text-brand-purple" data-id="element-292" data-mp="36wwgdfzhu573">{initials}</div>
        <div data-id="element-293" data-mp="2x2w3grxyzvnt">
          <div className="flex text-brand-gold" aria-label="5 de 5 estrellas" data-id="element-294" data-mp="2x2mkhobceorm">
            {Array.from({
            length: 5
          }, (_, index) => <StarIcon key={index} className="h-3.5 w-3.5 fill-current" aria-hidden="true" data-id="element-295" data-mp="v8dl5kwqkabv" />)}
          </div>
          <p className="mt-1 font-semibold text-brand-ink" data-id="element-296" data-mp="qbn7t5cbfsu5">{name}</p>
          <p className="text-xs text-brand-muted" data-id="element-297" data-mp="h5f19rwoi73u">{location} · {product}</p>
        </div>
      </div>
      <p className="font-serif text-base leading-relaxed text-brand-text" data-id="element-298" data-mp="m5kkqkssonau">“{text}”</p>
    </article>;
}
export function InitialTestimonials() {
  return <Section className="pt-6" data-id="element-299" data-mp="79lelfp8wx8c">
      <div className="mx-auto max-w-3xl" data-id="element-300" data-mp="c6vejpa9graf">
        <TestimonialCard initials="MG" name="María G." location="Córdoba" product="Terapeuta Reiki" text="Por primera vez tengo una estructura clara para cada sesión. Mis pacientes sienten la diferencia desde el primer encuentro. La confianza que transmite trabajar con método es inmediata." data-id="element-301" data-mp="c7wry0er1pvb" />
      </div>
    </Section>;
}
export function MoreTestimonials() {
  const testimonials: TestimonialProps[] = [{
    initials: 'MG',
    name: 'María G.',
    location: 'Córdoba',
    product: 'Terapeuta Reiki',
    text: 'Por primera vez tengo una herramienta que puedo abrir antes de cada sesión y saber exactamente qué voy a trabajar y por qué. La seguridad que transmite trabajar con sistema es total. Mis pacientes lo notan desde el primer encuentro.'
  }, {
    initials: 'JL',
    name: 'Julián L.',
    location: 'Buenos Aires',
    product: 'Terapeuta holístico',
    text: 'El nivel de detalle del Tomo 2 es impresionante. Tengo 20 protocolos listos para usar según el motivo de consulta. Nunca más llegué a una sesión sin saber exactamente qué hacer. No existe nada igual en español.'
  }, {
    initials: 'SM',
    name: 'Sofía M.',
    location: 'Rosario',
    product: 'Terapeuta Reiki en formación',
    text: 'Recién empezaba y el MEGA PACK me dio la estructura y la seguridad que necesitaba desde el primer paciente. El Reloj Maestro™ y el Ritual de los 15 Minutos™ solos valen todo el pack.'
  }, {
    initials: 'DL',
    name: 'Diego L.',
    location: 'Tucumán',
    product: 'Practicante holístico',
    text: 'El Bono de Fichas Profesionales transformó mi relación con cada paciente. Ahora tengo continuidad real en cada proceso. Mis sesiones tienen una profundidad completamente diferente a la de antes.'
  }];
  return <Section data-id="element-302" data-mp="32j08eyc53dd8">
      <div className="mb-10 text-center" data-id="element-303" data-mp="32j9xmjpd1ghv"><h2 className="font-display text-3xl font-bold text-brand-ink md:text-4xl" data-id="element-304" data-mp="37f7h2yvx72yv">LO QUE DICEN LOS TERAPEUTAS QUE YA LO TIENEN</h2></div>
      <div className="mx-auto grid max-w-4xl grid-cols-1 gap-6 md:grid-cols-2" data-id="element-305" data-mp="3cflhbura58mc">
        {testimonials.map(testimonial => <TestimonialCard key={testimonial.initials} {...testimonial} data-id="element-306" data-mp="3gekqxsnyhtk4" />)}
      </div>
    </Section>;
}